(() => {
  function initializePasswordLogin() {
    document.querySelectorAll('[data-password-login]').forEach((dialog) => {
      if (dialog.dataset.initialized) return;
      dialog.dataset.initialized = 'true';

      dialog.querySelector('[data-password-login-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        const url = new URL(window.location.href);
        if (url.searchParams.has('login')) {
          url.searchParams.delete('login');
          window.history.replaceState(window.history.state, '', url);
        }
        document.querySelector('.casa-password-signup__newsletter input')?.focus();
      });

      // Shopify may return password errors without retaining the query string.
      if (new URLSearchParams(window.location.search).get('login') === '1' ||
          dialog.querySelector('[data-password-login-error]')) {
        dialog.showModal();
      }
    });
  }

  initializePasswordLogin();
  document.addEventListener('shopify:section:load', initializePasswordLogin);
})();
